import { getAccessToken } from '@blaze-cms/core-auth-ui';

function getCookie(app) {
  const cookieString = app.ctx && app.ctx.req && app.ctx.req.headers.cookie;
  return getAccessToken(cookieString);
}
export default getCookie;
